import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=6039e3bc"
import script from "./partner.vue?vue&type=script&lang=js"
export * from "./partner.vue?vue&type=script&lang=js"
import style0 from "./partner.vue?vue&type=style&index=0&id=6039e3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports